import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconAiWrite",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], h = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.938 1a.5.5 0 0 1 .5.5v.424h.369a.5.5 0 1 1 0 1h-.37v.363a.5.5 0 0 1-1 0v-.363h-.43a.5.5 0 0 1 0-1h.43V1.5a.5.5 0 0 1 .5-.5Zm4.035.366a1.048 1.048 0 0 1 1.141.227h.001l.572.57a1.036 1.036 0 0 1 0 1.481l-2.083 2.07-.003.002-5.174 5.139a.5.5 0 0 1-.352.145h-1.35a.5.5 0 0 1-.5-.5V9.16a.5.5 0 0 1 .148-.355l7.26-7.211.001-.001c.097-.097.212-.174.339-.227Zm-.724 3.29 1.74-1.728a.033.033 0 0 0 .008-.038.036.036 0 0 0-.008-.012l-.005-.004-.577-.574a.048.048 0 0 0-.066 0l-.002.002L7.61 4.02l.64.636Zm-1.35.07.64.635L2.87 10h-.644v-.633L6.9 4.725ZM2.4 3.52a.5.5 0 0 1 .5.5v.394h.4a.5.5 0 0 1 0 1h-.4v.394a.5.5 0 1 1-1 0v-.394h-.4a.5.5 0 1 1 0-1h.4V4.02a.5.5 0 0 1 .5-.5Zm6.3 4.022a.5.5 0 0 1 .5.5v.394h.399a.5.5 0 0 1 0 1h-.4v.394a.5.5 0 0 1-1 0v-.394h-.4a.5.5 0 1 1 0-1h.4v-.394a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), _ = [
  h
];
function m(e, v, i, u, f, a) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--ai-write"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Ai Write",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, _, 10, c);
}
const Z = /* @__PURE__ */ o(s, [["render", m]]);
export {
  Z as default
};
//# sourceMappingURL=ai-write.js.map
